import React, { useEffect } from "react";
import Head from "next/head";
import Link from "next/link";
import funnel from "../styles/Funnel.module.css";
import Box from "@mui/material/Box";
import Footer from "../component/footer";

export default function PrivacyPolicy() {
  return (
    <>
      <Head>
        <title>Privacy Policy</title>
        <link
          rel="canonical"
          href="https://abodefinder.com.au/privacy-policy/"
        ></link>
        <meta name="description" content="" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" type="image/png" sizes="32x32" href="https://abodefinder.com.au/blog-static/img/favicon-32.ico"/>
      </Head>
      <div className={funnel.allFunnel}>
        <div className={funnel.funnelChance}>
          <div className={funnel.funnelBody} style={{ marginTop: "40px" }}>
            <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
              <div className={funnel.boxQn}>
                <div className={funnel.privacy}>
                  <p>Our Privacy Policy as at March 2021</p>
                  <br></br>
                  <p>Protecting your privacy</p>
                  <br></br>
                  <p>
                    abodefinder.com.au is operated by MasterAbode PTY LTD. (ACN
                    648 867 154). We are committed to providing you with the
                    highest levels of customer service. This includes protecting
                    your privacy. We comply with the Privacy Act 1988 (Cth) and
                    the Notifiable Data Breach scheme established under the Act.
                  </p>
                  <br></br>
                  <p>
                    Set out below is information that we are required to
                    communicate to our customers. We have also supplied
                    additional information about our website. By accessing our
                    website and using our services, you consent to the terms of
                    this Policy and agree to be bound by it. Your privacy
                    matters to us, so whether you are new to abodefinder.com.au
                    or a long-time user, please take the time to get to know our
                    practices.
                  </p>
                  <br></br>
                  <br></br>
                  <p>
                    In this document, 'abodefinder', 'buyeragentfinder'
                    ,'masterabode', 'MA', 'we', 'us' and 'our' are references to
                    MASTERABODE PTY LTD.
                  </p>
                  <br></br>
                  <br></br>
                  <p>How to contact us</p>
                  <br></br>
                  <p>You may contact us on the details below:</p>
                  <br></br>
                  <br></br>
                  <div style={{ fontSize: "1.1rem" }}>
                    Email:{" "}
                    <Link href="mailto:heretohelp@abodefinder.com.au">
                      heretohelp@abodefinder.com.au
                    </Link>
                  </div>
                  <br></br>
                  <br></br>
                  <h6>The Parties</h6>
                  <br></br>
                  <p>
                    If you are a natural person, then these Website Terms of Use
                    constitute a legally binding agreement between you and us
                    and govern your use of our Website.
                  </p>
                  <br></br>
                  <p>
                    If the user of our Website uses it in his or her capacity as
                    a representative of a body corporate (eg a corporation),
                    then it is a condition of the user continuing to use our
                    Website that the user warrants that he or she has authority
                    to accept these Website Terms of Use on behalf of that body
                    corporate, and these Website Terms of Use specify the terms
                    of a legally binding agreement between that body corporate
                    (and “You” in these Website Terms of Use means that body
                    corporate) and us.
                  </p>
                  <br></br>
                  <h6>General Information</h6>
                  <br></br>
                  <p>
                    The information appearing in this Website, except for when
                    it is described as a contract term or disclaimer, is for
                    general information only and does not constitute an offer or
                    an intention to enter into a legally binding contract, other
                    than the agreement between Us and You for the use of this
                    Website.
                  </p>
                  <br></br>
                  <h6>Your personal information</h6>
                  <br></br>
                  <p>
                    Your personal information and its protection are of the
                    utmost importance to us. When we refer to personal
                    information, we mean information or an opinion from which
                    your identity is apparent or can reasonably be ascertained.
                    Personal information held by us may include your name, age
                    or date of birth, current and previous addresses, telephone
                    or mobile phone number, email address, bank details,
                    professional job title or occupation, and financial details.
                    We may hold details of your products and services you have
                    acquired from us or have enquired about (including their
                    status) together with any additional information necessary
                    to deliver those products and services and to respond to
                    your enquiries.
                  </p>
                  <br></br>
                  <p>
                    The personal information we hold about you may also include
                    any finance that you have outstanding, your repayment
                    history in respect of those loans, and any defaults. we rely
                    on you to inform those individuals that you are providing
                    their personal information to us, to ensure they agree to
                    their information being provided to us, to advise them of
                    this privacy policy and that we can be contacted for further
                    information (see 'How to contact us' section).
                  </p>
                  <br></br>
                  <p>
                    If you choose not to provide certain personal information
                    (i) we may not be able to provide you with the services you
                    require or the level of service on which we aim to offer,
                    (ii) we may be unable to tailor our offering to your
                    preferences and (iii) your experience of our offering may
                    not be as enjoyable or as useful.
                  </p>
                  <br></br>
                  <h6>Sensitive information</h6>
                  <br></br>
                  <p>
                    Sensitive information is any information about your racial
                    or ethnic origin, political opinions, membership of a
                    political association, religious beliefs or affiliations,
                    philosophical beliefs, membership of a professional or trade
                    association, membership of a trade union, sexual preferences
                    or practices, criminal record or health information. We may
                    seek, collect, use, or disclose sensitive information about
                    you but only if that sensitive information is required for
                    one of the purposes noted under the 'How we use your
                    personal information' section of this Policy. This will
                    generally be for the purpose of verifying your identity or
                    income.
                  </p>
                  <br></br>
                  <p>
                    You expressly provide your consent to us receiving this
                    information and holding it for the purposes outlined in this
                    policy.
                  </p>
                  <br></br>
                  <h6>How we collect personal and credit information</h6>
                  <br></br>
                  <p>
                    We may collect personal information in a number of ways,
                    including:
                  </p>
                  <br></br>
                  <p>
                    directly from you, for example, when you provide information
                    by phone, in application forms, or other agreements, or when
                    you submit your personal details through our websites (e.g.
                    during an application or via abodefinder.com.au);
                  </p>
                  <br></br>
                  <p>
                    from your joint applicants, co-applicants or guarantors;
                  </p>
                  <br></br>
                  <p>when you visit our websites;</p>
                  <br></br>
                  <p>
                    from third parties such as our survey or competition
                    websites, marketing websites, related companies, referral
                    companies;
                  </p>
                  <br></br>
                  <p>
                    from your representatives, e.g. solicitors, conveyancers,
                    builders, agents;
                  </p>
                  <br></br>
                  <p>from referral partners, who refer your business to us;</p>
                  <br></br>
                  <p>
                    from the organisations and entities identified under the
                    'When we disclose your personal information' section below,
                    including our related entities;
                  </p>
                  <br></br>
                  <p>from publicly available sources of information;</p>
                  <br></br>
                  <p>from our own records; and/or</p>
                  <br></br>
                  <p>
                    when legally required to do so -- for example, in the
                    provision of specific credit services.
                  </p>
                  <br></br>
                  <p>
                    If we have obtained your information through any of these
                    methods and you would like a list of these entities or
                    websites, please contact us at{" "}
                    <Link href="mailto:heretohelp@abodefinder.com.au">
                      heretohelp@abodefinder.com.au
                    </Link>
                    .
                  </p>
                  <br></br>
                  <p>
                    If you feel you have not given us consent to use your
                    details or would like to be removed from our call or email
                    lists, please contact us at{" "}
                    <Link href="mailto:heretohelp@abodefinder.com.au">
                      heretohelp@abodefinder.com.au
                    </Link>
                    .
                  </p>
                  <br></br>
                  <h6>How we use your personal information</h6>
                  <br></br>
                  <p>
                    The primary purpose for which we collect information about
                    you is to enable us to perform our business activities and
                    functions and to provide the best possible quality of
                    customer experience.
                  </p>
                  <br></br>
                  <p>
                    Your personal information is also collected so that we and
                    our related entities can promote and market services to you
                    (including by way of direct mail, telemarketing, email, SMS
                    and MMS messages) (Marketing Services) in accordance with
                    any applicable marketing laws (secondary purposes). This is
                    to keep you informed of products, services and special
                    offers and we may continue after you cease holding an active
                    product or service through us. If you do not wish for this
                    to take place or continue, please contact us via{" "}
                    <Link href="mailto:heretohelp@abodefinder.com.au">
                      heretohelp@abodefinder.com.au
                    </Link>
                    .
                  </p>
                  <br></br>
                  <h6>When we disclose your personal information</h6>
                  <br></br>
                  <p>
                    Your information may be disclosed to persons or companies
                    (our partners or referral partners) for the purposes noted
                    above.
                  </p>
                  <br></br>
                  <br></br>
                  <p>
                    In order to deliver the services, you require we may
                    disclose your personal information to people or
                    organisations outside of our external service providers
                    companies. This may include:
                  </p>
                  <br></br>
                  <br></br>
                  <p>your joint applicants, co-applicants or guarantors;</p>
                  <br></br>
                  <p>
                    your representatives or advisors (e.g. your solicitors,
                    accountants, conveyancers, builders, agents);
                  </p>
                  <br></br>
                  <p>
                    our professional advisors, including our accountants,
                    auditors, and lawyers;
                  </p>
                  <br></br>
                  <p>
                    organisations who manage our business, marketing and
                    corporate strategies and/or sponsors or promoters of any
                    competition that we conduct to promote our services;
                  </p>
                  <br></br>
                  <p>
                    credit providers, funders, agents, Australian Banks, and
                    non-bank lenders (e.g. for credit-related purposes such as
                    credit approval, credit-worthiness, credit rating, credit
                    provision and financing);
                  </p>
                  <br></br>
                  <p>
                    our related entities (e.g. companies, and their respective
                    partnerships, joint venture entities, agents, contractors or
                    external service providers for the operation of their
                    business);
                  </p>
                  <br></br>
                  <p>
                    our referral partners, business partners or joint venture
                    partners;
                  </p>
                  <br></br>
                  <p>providers of credit, financial, or insurance services;</p>
                  <br></br>
                  <p>mortgage insurers and title insurers;</p>
                  <br></br>
                  <p>
                    other comparison sites, mortgage brokers, or providers of
                    investment finance, or credit (where legal for us to do so);
                  </p>
                  <br></br>
                  <p>
                    the police or other relevant authorities or enforcement
                    bodies;
                  </p>
                  <br></br>
                  <p>
                    government and regulatory authorities or organisations (such
                    as our External Dispute Resolution Scheme or ASIC, as
                    required or authorised by law); and/or
                  </p>
                  <br></br>
                  <p>
                    internet service providers or network administrators (for
                    example, if we have reason to suspect you have committed a
                    breach of our terms and conditions or have otherwise been
                    engaged in any unlawful activity and we reasonably believe
                    such disclosure is necessary).
                  </p>
                  <br></br>
                  <p>
                    We may use external organisations or third parties for
                    customer enquiries; Professional services such as financial
                    advisors, Loan brokers, solicitors, homebuyers advocate,
                    real estate agents, property managers; mailing operations;
                    billing and debt-recovery functions; information technology
                    services; marketing and telemarketing market research; and
                    website usage analysis. This means we disclose your personal
                    information to them.
                  </p>
                  <br></br>
                  <p>
                    You expressly consent to us providing your information to
                    the persons or organisations above for our primary credit
                    activities or secondary purposes.
                  </p>
                  <br></br>
                  <p>
                    Your personal information is disclosed to these
                    organisations only in relation to us providing our services
                    to you including our referral partners such as brokers,
                    agents or advisors. We take reasonable steps to ensure that
                    these organisations are bound by confidentiality and privacy
                    obligations in relation to the protection of your personal
                    information.
                  </p>
                  <br></br>
                  <p>
                    Where your personal information is provided to a lender or
                    broker for the purpose of a loan application, you should
                    know that the lender or broker may list a credit enquiry on
                    your credit file, and will be required to report certain
                    details about your credit information to CRBs under the
                    Comprehensive Credit Reporting (CCR) regime.
                  </p>
                  <br></br>
                  <h6>Transfer of information overseas</h6>
                  <br></br>
                  <p>
                    In order to supply you with the best service possible, we
                    may transfer personal information we have collected about
                    you to someone in a foreign country, but only if permitted
                    to do so under the Australian Privacy Principles.
                  </p>
                  <br></br>
                  <p>
                    Some of the above external organisations and entities may be
                    located outside of Australia. You should note that while
                    they will often be subject to confidentiality or privacy
                    obligations, they may not always follow the particular
                    requirements of Australian privacy laws. Overseas
                    organisations may be required to disclose the information we
                    share with them under a foreign law. In those instances, we
                    will not be responsible for that disclosure.
                  </p>
                  <br></br>
                  <p>
                    We do not utilise offshore personnel for the purposes of
                    marketing or sales. We will not share any of your credit
                    information with a credit reporting body unless it has a
                    business operation in Australia.
                  </p>
                  <br></br>
                  <h6>Unsolicited information</h6>
                  <br></br>
                  <p>
                    Sometimes people share information (including sensitive
                    information) with us we have not sought out. This could be
                    through using our website or, for example, requesting us to
                    assess or assist in a hardship application.
                  </p>
                  <br></br>
                  <p>
                    If we receive unsolicited personal information (including
                    sensitive information) about you, we will determine whether
                    we would have been permitted to collect that information. If
                    yes, then we will handle this information the same way we do
                    with other information that we seek from you. If we
                    determine that we would not have been permitted to collect
                    that information, and the information is not contained in a
                    Commonwealth record, then we will destroy or de-identify it
                    as soon as practicable, but only if it is lawful and
                    reasonable to do so. Often, it is not possible for us to
                    neatly unbundle this information then destroy or de-identify
                    only certain sections or parts of it, and we may need to
                    store this information for future use, such as to help
                    resolve disputes between us or assess future applications by
                    you.
                  </p>
                  <br></br>
                  <p>
                    We have many security safeguards in place to protect the
                    information from interference, misuse, loss, unauthorised
                    access, modification or disclosure.
                  </p>
                  <br></br>
                  <h6>Direct Marketing</h6>
                  <br></br>
                  <p>
                    We take pride in the products and services that we offer.
                    And we love keeping you informed as to the best offers in
                    the financial and property market place. However, first and
                    foremost we respect your privacy and understand that not
                    everyone wants to be contacted regarding sales and
                    marketing.
                  </p>
                  <br></br>
                  <p>
                    If you do not wish to be contacted by abodefinder or
                    referral partners such as brokers, real estate agents,
                    property experts, financial advisors, property managers we
                    invite you to contact us via{" "}
                    <Link href="mailto:heretohelp@abodefinder.com.au">
                      heretohelp@abodefinder.com.au
                    </Link>{" "}
                    and we will remove you from our call and email lists.
                  </p>
                  <br></br>
                  <p>
                    We may conduct marketing activities via email, telephone,
                    SMS, IM, mail, or any other electronic means. We may also
                    market our products to you through third-party channels
                    (such as social networking sites). We will always let you
                    know that you can opt-out from receiving our third-party
                    marketing. Where we market to prospective customers, we will
                    always provide an easy way to opt-out.
                  </p>
                  <br></br>
                  <p>
                    We disclose your personal information to third parties or
                    referral partners such as brokers, real estate agents,
                    property experts, financial advisors, property managers, or
                    for the purpose of connecting you with other businesses or
                    customers. You can ask us not to do this at any time.
                  </p>
                  <br></br>
                  <h6>Opt-Out</h6>
                  <br></br>
                  <p>
                    You can let us know at any time if you no longer wish to
                    receive direct marketing offers from abodefinder by emailing
                    your request to{" "}
                    <Link href="mailto:heretohelp@abodefinder.com.au">
                      heretohelp@abodefinder.com.au
                    </Link>
                    . We will process your request as soon as we can.
                  </p>
                  <br></br>
                  <p>Cookies and web beacons</p>
                  <br></br>
                  <p>Cookies</p>
                  <br></br>
                  <p>
                    A 'cookie' is a small text file placed on your computer by a
                    webpage server that may later be retrieved by webpage
                    servers. We use cookies on our website to provide you with a
                    better website experience. When you visit the
                    abodefinder.com.au website or related landing pages to read,
                    browse, submit or download information, our system will
                    record/log your IP address, date and time of your visit to
                    our site, the pages viewed and any information downloaded.
                    We may automatically collect non-personal information about
                    you such as the site from which you linked to our websites.
                    We do not personally identify you with this information. You
                    can configure your browser to refuse cookies or delete
                    existing cookies from your hard drive. Rejecting cookies may
                    have the effect of limiting access to or functionality of
                    parts of our website.
                  </p>
                  <br></br>
                  <p>
                    We generally use this information to report statistics,
                    analyse trends, administer our services, diagnose problems
                    and target and improve the quality of our products and
                    services.
                  </p>
                  <br></br>
                  <p>Web beacons</p>
                  <br></br>
                  <p>
                    A web beacon is typically a transparent graphic image
                    invisible to the user that is placed on a website. The use
                    of a web beacon allows the website to record the simple
                    actions of the user (such as opening the page that contains
                    the beacon) through a tracking pixel. We may use web beacons
                    (and cookies) for purposes such as site usage analytics,
                    advertising auditing and reporting, as well as content and
                    "advertising/marketing personalisation". We may share any
                    data collected from web beacon (and cookies) with third
                    parties to provide you with relevant advertising when
                    browsing Third-Party networks and websites (Third-Party
                    Websites) such as Google and Facebook.
                  </p>
                  <br></br>
                  <h6>Information from third parties</h6>
                  <br></br>
                  <p>
                    Our website may contain links to Third-Party Websites (e.g.
                    third-party providers of goods and services). We make no
                    representations or warranties in relation to the privacy
                    practices of any Third Party Website and we are not
                    responsible for the privacy policies or the content of any
                    third-party website. Third-Party Websites are responsible
                    for informing you about their own privacy practices. If you
                    accessed Third-Party Websites through our website and if
                    those third parties collect information about you, we may
                    also collect or have access to that information as part of
                    our arrangements with those third parties.
                  </p>
                  <br></br>
                  <p>
                    Where you access a Third-Party Website from our website,
                    cookie and web beacon information, information about your
                    preferences or other information you have provided about
                    yourself may be shared between us and the third party.
                  </p>
                  <br></br>
                  <h6>Advertising and tracking</h6>
                  <br></br>
                  <p>
                    We may advertise on Third-Party Websites. When you view our
                    advertisements on Third-Party Websites, the advertising
                    company may use cookies, and in some cases, web beacons, to
                    collect information such as the server your computer is
                    logged onto, your browser type, the date and time of your
                    visit and the performance of their marketing efforts. When
                    you access our website after viewing one of our
                    advertisements on a Third-Party Website, the advertising
                    company may collect information on how you utilise our
                    website (e.g. which pages you view) and whether you
                    commenced or completed an online application.
                  </p>
                  <br></br>
                  <h6>Using our website and any of our online tools</h6>
                  <br></br>
                  <p>
                    When you use our website, any of our online tools, or any of
                    our online platforms to compare or choose loans, suburbs,
                    properties,agents, advisors, we may share your personal
                    information with lenders,agencies, referral partners,
                    business partners and joint venture partners to assist you
                    in the loan financing process or buying property. This is to
                    enable us to provide services. The information we may share
                    include any of your personal information (such as your age),
                    but in particular, the information may include matters
                    relating to your income, expenditure, assets, liabilities,
                    and your Credit Reporting Information and any similar
                    information to enable the making of an assessment to provide
                    the rating. Our referral partners include loan brokers, real
                    estate agents, property experts, financial advisors with
                    whom we may share your personal information in order to
                    provide you different services. Our referral partners have
                    safeguards in place to protect the information and they are
                    not permitted to use the information for purposes other than
                    to provide services.
                  </p>
                  <br></br>
                  <p>
                    Referral Business Partners have been selected for their
                    strategic focus and skills. abodefinder does refer clients
                    to Referral Business Partners. The partners’ role is to
                    ensure the client receives the right advice and service.
                  </p>
                  <br></br>
                  <p>
                    We expect our Referral Business Partners to provide the
                    highest levels of services and products to our clients and
                    ensure to meet the standards and needs of our clients, as we
                    deliver the same levels of services to our Business
                    Partners’ clients.
                  </p>
                  <br></br>
                  <h6>Online applications</h6>
                  <br></br>
                  <p>
                    When you send a completed online application to us, we
                    retain the information contained in that application. We are
                    able to then use that information to provide any services
                    that you require. You may also be able to suspend and save
                    online applications, so you can complete and send the
                    applications at a later time. If you suspend or save your
                    application, the information that you have entered will be
                    retained in our systems so that you may recover the
                    information when you resume your application. Online
                    applications that have been suspended or saved may be viewed
                    by us.
                  </p>
                  <br></br>
                  <h6>Consent</h6>
                  <br></br>
                  <p>
                    By providing your phone number or email address and then
                    clicking submit on any online form, application, calculator,
                    tool or query, you consent to receiving notices and other
                    documents from us by call, SMS or email to the email address
                    provided, and you understand that if you give this consent:
                    we may no longer send you paper copies of notices and other
                    documents; you should regularly check your email address for
                    documents, and you may withdraw your consent to receiving
                    documents by email at any time. You also confirm that you
                    have the facilities to print any notice or document that we
                    send you by email if required.
                  </p>
                  <br></br>
                  <h6>Accurate information</h6>
                  <br></br>
                  <p>
                    We take all reasonable precautions to ensure that the
                    personal information we collect, use and disclose is
                    accurate, complete and up-to-date. However, the accuracy of
                    that information depends to a large extent on the
                    information you or others provided to us. If you wish to
                    make any changes to your personal information, please
                    contact us at{" "}
                    <Link href="mailto:heretohelp@abodefinder.com.au">
                      heretohelp@abodefinder.com.au
                    </Link>
                    .
                  </p>
                  <br></br>
                  <p>
                    We will generally rely on you to assist us in informing us
                    if the information we hold about you is inaccurate or
                    incomplete. You may request access to the personal
                    information we hold about you by contacting us. We will
                    respond to your request within a reasonable period. We will
                    give access in the manner you have requested if it is
                    reasonable to do so. We may charge you a fee to access the
                    information. The fee will not be excessive and will not
                    apply to the making of the request. We may deny you access
                    to your personal information in certain circumstances, for
                    example, if required or authorised by or under an Australian
                    law or a court/tribunal order, or it would be likely to
                    prejudice enforcement related activities by an enforcement
                    body, if granting access would interfere with the privacy of
                    others, or if it would result in a breach of
                    confidentiality. If we decide not to give you access, we
                    will provide reasons for the refusal and information on how
                    you can complain about the refusal.
                  </p>
                  <br></br>
                  <h6>Storage and security</h6>
                  <br></br>
                  <p>
                    We store information in different ways, including in paper
                    and electronic form.
                  </p>
                  <br></br>
                  <p>
                    The security of your personal information is important to us
                    and we take reasonable steps to protect it from misuse,
                    interference and loss, and from unauthorised access,
                    modification or disclosure. Some of the ways we do this are:
                    confidentiality requirements of our employees; document
                    storage security policies; security measures for access to
                    our systems; only giving access to personal information to a
                    person who is verified to be able to receive that
                    information; control of access to our buildings; and
                    electronic security systems, such as firewalls and data
                    encryption on our websites.
                  </p>
                  <br></br>
                  <p>
                    We take protecting the security of your personal information
                    seriously. We have a response plan that is designed to
                    enable us to contain, assess and respond to suspected data
                    breaches in a timely fashion, and to help mitigate potential
                    harm to affected individuals.
                  </p>
                  <br></br>
                  <p>
                    We may store your information in cloud or other types of
                    networked or electronic storage. As electronic or networked
                    storage can be accessed from anywhere via an internet
                    connection, it is not always practicable to know in which
                    country your information may be held. If your information is
                    stored in this way, disclosures may occur in countries other
                    than those listed here or those we referred to from time. In
                    addition to the above, we also regularly review developments
                    in security and encryption technologies. However, it is
                    important to remember that the use of email and the internet
                    may not always be secure, even with these safeguards in
                    place.
                  </p>
                  <br></br>
                  <p>
                    When we no longer require your information, and we are
                    legally permitted to, we take reasonable steps to destroy or
                    de-identify the information. However, sometimes it is
                    impossible or impractical to completely isolate the
                    information then completely remove all traces of the
                    information, and we may store the information for future
                    use, such as to help resolve disputes between us or assess
                    future applications by you. The same security safeguards
                    will be in place to protect the information, as detailed in
                    this Privacy Policy.
                  </p>
                  <br></br>
                  <h6>Doing business without identifying you</h6>
                  <br></br>
                  <p>
                    In most circumstances, it will be necessary for us to
                    identify you in order to successfully do business with you.
                    However, where it is lawful and practicable to do so, we
                    will provide you with the option to remain anonymous or to
                    use a pseudonym, for example, when you make general
                    inquiries about our business or current promotional offers.
                    We do not adopt a government related identifier (such as
                    your tax file number or your driver's license number) as a
                    means of identifying you.
                  </p>
                  <br></br>
                  <p>Complaints and further information</p>
                  <br></br>
                  <p>
                    If you have a complaint about how we handle your personal
                    information, we want to hear from you.
                  </p>
                  <br></br>
                  <p>Internal Dispute Resolution (IDR)</p>
                  <br></br>
                  <p>
                    You are always welcome to contact us to let us know about
                    your complaint at:
                  </p>
                  <br></br>
                  <div style={{ fontSize: "1.1rem" }}>
                    Email:{" "}
                    <Link href="mailto:heretohelp@abodefinder.com.au">
                      heretohelp@abodefinder.com.au
                    </Link>
                  </div>
                  <br></br>
                  <p>
                    We have a formal procedure for investigating and dealing
                    with privacy breaches or complaints. Once the Privacy
                    Officer receives a complaint, whether it is in writing or
                    verbal means, the Privacy Officer will commence an
                    investigation with the relevant business unit from which the
                    alleged breach stemmed. The investigator will endeavour to
                    determine the nature of the breach and how it occurred. We
                    may contact you during the process to seek any further
                    clarification if necessary. If a breach is found, the
                    Privacy Officer will escalate the matter to management so
                    that the process can be rectified to prevent any further
                    breaches from taking place. We will also contact you to
                    inform you of the outcome of the investigation. We will
                    endeavour to resolve all investigations within a reasonable
                    time.
                  </p>
                  <br></br>
                  <p>
                    By giving us as much information as possible, you will help
                    us resolve things faster. If you have any supporting
                    documentation, please have it handy when you raise your
                    concern(s). We will try to acknowledge your complaint within
                    5 business days and try to respond to your complaint within
                    45 days. Where we are unable to do so, we will send you an
                    email or letter advising of the reasons for any delay, and
                    your right to complain to our EDR scheme.
                  </p>
                  <br></br>
                </div>
              </div>
            </Box>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
